'user strict'
const ex = require('../lib/error')
const moment = require('moment')
const Sequelize = require('../config/db')

const sequelize = require('sequelize')
const Op = sequelize.Op
const messages = require('../models').messages
const excel = require('exceljs')

const createPassiveData = (req, res, next) => {
    messages.create(req.body)
    .then(info => {
        req.responseObject.data.info = info
        next()
    })
    .catch(error => {
        let errCode
        if(error.name === 'SequelizeUniqueConstraintError'){
            errCode = 'MAUD003'
        }else{
            errCode = 'MAUD004'
        }
        ex.raiseError(req, res, errCode, 500, error)
    })
}

const getPassiveDataForExport = (req, res, next) => {

    let where = {
        createdAt: {
          [Op.between]: [moment().subtract(req.params.noMonth, 'months').startOf('months'),
          moment().subtract(req.params.noMonth, 'months').endOf('months')]
        }
    }

    messages
    .findAll({
        where: where,
        order: [['messageDate', 'DESC']]
    })
    .then(messages => {
      req.responseObject.messageCode = 'OVA005'
      req.responseObject.data.messages = messages
      next()
    })
    .catch(error => {
      let errCode
      errCode = 'OVA006'
      ex.raiseError(req, res, errCode, 500, error)
    })
}

const generateXlsForPassiveData = (req, res, next) => {
    let rowNo = 1
    const workbook = new excel.Workbook();
    const passiveData = workbook.addWorksheet('Passive Data');
    const A = 'A'
    const B = 'B'
    const C = 'C'
    const D = 'D'
    const E = 'E'
    const F = 'F'
    const G = 'G'
    const H = 'H'
    const I = 'I'
    const J = 'J'
  
    passiveData.getCell(A + rowNo).value = "Message Id"
    passiveData.getCell(B + rowNo).value = "_id"
    passiveData.getCell(C + rowNo).value = "User Id"
    passiveData.getCell(D + rowNo).value = "Address"
    passiveData.getCell(E + rowNo).value = "Body"
    passiveData.getCell(F + rowNo).value = "Message Date"
    passiveData.getCell(G + rowNo).value = "Android Version"
    passiveData.getCell(H + rowNo).value = "Phone Model"
    passiveData.getCell(I + rowNo).value = "Created Date"
    passiveData.getCell(J + rowNo).value = "Modified Date"
  
    rowNo++
    req.responseObject.data.messages.forEach(message => {
        passiveData.getCell(A + rowNo).value = message.messageId
        passiveData.getCell(B + rowNo).value = message._id
        passiveData.getCell(C + rowNo).value = message.userid
        passiveData.getCell(D + rowNo).value = message.address
        passiveData.getCell(E + rowNo).value = message.body
        passiveData.getCell(F + rowNo).value = message.messageDate
        passiveData.getCell(G + rowNo).value = message.androidVersion
        passiveData.getCell(H + rowNo).value = message.phoneModel
        passiveData.getCell(I + rowNo).value = message.createdAt
        passiveData.getCell(J + rowNo).value = message.updatedAt
        rowNo++
    });
    const fileName = "PassiveDatas_" + new Date().getTime() + ".xls"
    workbook.xlsx.writeFile(__dirname + '/../../public/passivedatas/' + fileName)
    req.responseObject.data = "http://" + (req.headers.host ? req.headers.host : req.connection.remoteAddress) + "/passivedatas/" + fileName
    next()
  }

module.exports = {
    createPassiveData,
    getPassiveDataForExport,
    generateXlsForPassiveData
}